<template>
  <div v-click-outside="hide" style="cursor: pointer;">
    <span class="adp-p adp-p__green" @click="open">
      {{ text ? text : $t('catalog.all') }} <img src="/images/arrow_blue.svg" alt="" style="margin-top: -4px;">
    </span>
    <div v-if="isVisible">
      <div class="position-absolute adp-dd-options">
        <div class="d-flex flex-column">
          <div class="adp-p adp-dd-option d-flex justify-content-between align-items-center" @click="selected = []">
            <span class="apd-p">{{ $t('catalog.all') }}</span>
          </div>
          <div class="adp-p adp-dd-option d-flex justify-content-between align-items-center"
               @click="selected = [option.id]" v-for="(option, i) in options">
            <span class="apd-p" style="width: calc(100% - 32px);">{{ option.name }}</span>
            <button class="adp-btn-outline" @click.stop="editTemplate(option.id)" style="width: 48px; height: 48px; margin: -10px -16px;">
              <img src="/images/pencil.svg" alt="" style="margin-top: -4px;">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {updateUrl} from "../updateUrl";

export default {
  name: 'MyTemplateFilter',
  props: {
    options: {
      type: Array,
      required: true,
    },
    initSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: this.initSelected,
      allSelected: false,
      indeterminate: false,
      isVisible: false,
      text: '',
    };
  },
  watch: {
    selected(newVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
        this.text = '';
        this.updateUrl({filterTemplates: null});
      } else {
        this.indeterminate = true;
        this.allSelected = false;
        this.text = this.options
          .map(element => (newVal.slice().includes(element.id) ? element.code : false))
          .filter(element => element)
          .join(', ');
        this.updateUrl({filterTemplates: this.selected.join('_')});
      }
      this.$emit('my-change', this.selected);
    },
  },
  methods: {
    editTemplate(id) {
      this.$emit('edit-template', {id});
    },
    hide() {
      this.isVisible = false;
    },
    open() {
      this.isVisible = true;
    },
    ok() {
      this.hide();
      this.$emit('my-change', this.selected);
    },
    updateUrl(params) {
      updateUrl(params);
    }
  },
  mounted() {
    this.text = this.options
      .map(element => (this.initSelected.slice().includes(element.id) ? element.code : false))
      .filter(element => element)
      .join(', ');

    if (this.initSelected.length === this.options.length) {
      this.allSelected = true;
    }
  },
};
</script>

<style scoped>
>>> .adp-dd-options {
  max-width: 310px;
  right: 20px;
}
</style>
